import { render, staticRenderFns } from "./ShopifyMigrationWizard.vue?vue&type=template&id=438bf65f&scoped=true"
import script from "./ShopifyMigrationWizard.vue?vue&type=script&lang=ts"
export * from "./ShopifyMigrationWizard.vue?vue&type=script&lang=ts"
import style0 from "./ShopifyMigrationWizard.vue?vue&type=style&index=0&id=438bf65f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438bf65f",
  null
  
)

export default component.exports